import { Enum_LiveStream_Status, } from '@core/api';
import { isIVS } from '@src/embeds/utils/videoElementWrapper/helpers';
import { ILiveStreamState } from '../../store/types';
export const isLiveStream = (video) => (video === null || video === void 0 ? void 0 : video.video_type) === 'live_stream';
export const isStreamingLive = (liveStreamState) => liveStreamState !== null &&
    [
        ILiveStreamState.ACTIVE_WAITING,
        ILiveStreamState.ACTIVE_PLAYING,
        ILiveStreamState.ACTIVE_PAUSED,
    ].includes(liveStreamState);
export const isStreamingLivePlaying = (liveStreamState) => liveStreamState !== null &&
    [ILiveStreamState.ACTIVE_PLAYING, ILiveStreamState.ACTIVE_PAUSED].includes(liveStreamState);
export const isStreamingReplay = (liveStreamState) => liveStreamState !== null &&
    ILiveStreamState.REPLAY_PLAYING === liveStreamState;
export const isStreamingActiveOrReplay = (video, liveStreamState) => {
    return (isLiveStream(video) &&
        (isStreamingLive(liveStreamState) || isStreamingReplay(liveStreamState)));
};
export const getElapsedTime = (video, videoEl) => {
    if ((video === null || video === void 0 ? void 0 : video.live_stream_status) !== Enum_LiveStream_Status.ACTIVE &&
        (video === null || video === void 0 ? void 0 : video.live_stream_status) !== Enum_LiveStream_Status.PAUSED) {
        return videoEl.currentTime;
    }
    const latency = isIVS(videoEl) ? getLatency(videoEl) : 0;
    const now = Date.now() / 1000;
    const startedAt = (video === null || video === void 0 ? void 0 : video.live_stream_started_at)
        ? new Date(video === null || video === void 0 ? void 0 : video.live_stream_started_at).getTime() / 1000
        : Date.now() / 1000;
    return (video === null || video === void 0 ? void 0 : video.live_stream_started_at) ? now - startedAt - latency : 0;
};
export const getLatency = (videoEl) => {
    return videoEl.latency || 0;
};
export const chatMessageToLiveStreamMessage = (chatMessage) => {
    const { id, text, user_type, username, elapsed_time, reply } = chatMessage;
    return {
        event_type: 'message',
        id,
        text,
        user_type,
        username,
        elapsed_time,
        reply,
    };
};
export const eventToLiveStreamEvent = (event) => {
    const { action_id, action_type, elapsed_time, user_type, payload } = event;
    return {
        event_type: action_type,
        id: action_id,
        payload,
        user_type,
        elapsed_time,
    };
};
export const byElapsedTimeAsc = (a, b) => {
    if (a.elapsed_time === undefined || b.elapsed_time === undefined) {
        return -1;
    }
    return a.elapsed_time >= b.elapsed_time ? -1 : 1;
};
export const byElapsedTimeDESC = (a, b) => (a.elapsed_time >= b.elapsed_time ? 1 : -1);
